import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export interface Item {
  id: any
  name: string
  region_id?: number
  slug?: string
  value?: boolean | string
}

export default class FilterFields extends BaseModel {
  static override constructorName = 'FilterFields'

  name: string = ''
  type: 'checkbox' | 'multiselect' | 'selectedvalues' | 'search' | 'sort' | 'range' = 'multiselect'

  title: string = ''
  placeholder: string = ''
  items: Item[] = []
  includes: any = null
  range_min?: number = 0
  range_max?: number = 100
  range_step?: number = 1
  value: any = null

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(FilterFields)
